import type { GaApp } from '~/modules/app'
import type { PrizeModel, RatingPreviousModalData } from '~/modules/main'

export class ModalService {
  gaApp: GaApp

  constructor(gaApp: GaApp) {
    this.gaApp = gaApp
  }

  /** Возвращает флаг состояния модалки ежедневной награды */
  getDailyRewardModalState() {
    return this.gaApp.stores.main.modals.dailyReward.isOpened
  }

  /** Открытие модалки ежедневной награды */
  openDailyRewardModal() {
    this.gaApp.stores.main.modals.dailyReward.isOpened = true
  }

  /** Закрытие модалки ежедневной награды */
  closeDailyRewardModal() {
    this.gaApp.stores.main.modals.dailyReward.isOpened = false
  }

  /** Возвращает флаг состояния модалки приза */
  getPrizeModalState() {
    return this.gaApp.stores.main.modals.prize.isOpened
  }

  /** Возвращает флаг состояния промо модалки */
  getPromoModalState() {
    return this.gaApp.stores.main.modals.promo.isOpened
  }

  /** Открытие промо модалки */
  openPromoModal() {
    this.gaApp.stores.main.modals.promo.isOpened = true
  }

  /** Закрытие промо модалки */
  closePromoModal() {
    this.gaApp.stores.main.modals.promo.isOpened = false

    void this.gaApp.services.main.api.updatePromoModalState()
  }

  /** Возвращает флаг состояния модалки переключения языков */
  getLanguageSwitcherModalState() {
    return this.gaApp.stores.main.modals.languageSwitcher.isOpened
  }

  /** Открытие модалки переключения языков */
  openLanguageSwitcherModal() {
    this.gaApp.stores.main.modals.languageSwitcher.isOpened = true
  }

  /** Закрытие модалки переключения языков */
  closeLanguageSwitcherModal() {
    this.gaApp.stores.main.modals.languageSwitcher.isOpened = false
  }

  /** Открытие модалки приза с возможной записью приза в стор */
  // TODO: обновление данных пользователя
  openPrizeModal(prize?: PrizeModel) {
    if (prize) {
      this.setPrizeData(prize)
    }

    this.gaApp.stores.main.modals.prize.isOpened = true
  }

  /** Закрытие модалки приза */
  closePrizeModal() {
    this.gaApp.stores.main.modals.prize.isOpened = false
  }

  /** Получение данных модалки приза */
  getPrizeData() {
    return this.gaApp.stores.main.modals.prize.data
  }

  /** Сохранение данных модалки приза */
  setPrizeData(prize: PrizeModel | null) {
    this.gaApp.stores.main.modals.prize.data = prize
  }

  /** Скрытие рулетки */
  hideRoulette(): void {
    this.gaApp.stores.main.modals.prize.hideRoulette = true
  }

  /** Отображение рулетки */
  showRoulette(): void {
    this.gaApp.stores.main.modals.prize.hideRoulette = false
  }

  /** Возвращает флаг состояния модалки итогов прошлого рейтинга */
  getRatingPreviousModalState() {
    return this.gaApp.stores.main.modals.ratingPrevious.isOpened
  }

  /** Получение данных модалки итогов прошлого рейтинга */
  getRatingPreviousModalData() {
    return this.gaApp.stores.main.modals.ratingPrevious.data
  }

  /** Открытие модалки итогов прошлого рейтинга */
  openRatingPreviousModal(data: RatingPreviousModalData) {
    this.gaApp.stores.main.modals.ratingPrevious.data = data
    this.gaApp.stores.main.modals.ratingPrevious.isOpened = true
  }

  /** Закрытие модалки итогов прошлого рейтинга */
  closeRatingPreviousModal() {
    this.gaApp.stores.main.modals.ratingPrevious.isOpened = false
  }

  /** Сброс данных модалки итогов прошлого рейтинга (после анимации закрытия) */
  clearRatingPreviousModalData() {
    this.gaApp.stores.main.modals.ratingPrevious.data = null
  }

  /** Возвращает флаг состояния модалки итогов рейтинга */
  getRatingResultsModalState() {
    return this.gaApp.stores.main.modals.ratingResults.isOpened
  }

  /** Открытие модалки итогов рейтинга */
  openRatingResultsModal() {
    this.gaApp.stores.main.modals.ratingResults.isOpened = true
  }

  /** Закрытие модалки итогов рейтинга */
  closeRatingResultsModal() {
    this.gaApp.stores.main.modals.ratingResults.isOpened = false

    if (this.gaApp.stores.main.user.data) {
      this.gaApp.stores.main.user.data.showRatingResultsModal = false
    }

    void this.gaApp.services.main.api.updateRatingResultsModalState()
  }

  /** Возвращает флаг состояния онбординг-модалки */
  getOnboardingModalState() {
    return this.gaApp.stores.main.modals.onboarding.isOpened
  }

  /** Открытие stories-онбординга */
  openOnboardingModal() {
    this.gaApp.stores.main.modals.onboarding.isOpened = true
  }

  /** Закрытие stories-онбординга */
  async closeOnboardingModal() {
    this.gaApp.stores.main.modals.onboarding.isOpened = false

    try {
      await this.gaApp.services.main.api.updatePromoModalState()
    } catch (error) {
      console.error('Onboarding modal state update error:', error)
    }
  }
}
